export class Direccion {
  calle: string;
  numero: string;
  bloque: string;
  altura: string;
  letra: string;
}
